import styled, { css } from 'styled-components';
import { CODE_FONT_FAMILY } from '@stylesheets/font';
import { LoginStepContent, LoginForm } from '../Login/Login.styled';

export const MfaContent = styled(LoginStepContent)`
  [data-testid$="__subtitle"] {
    white-space: normal;
  }
`;

export const MfaFormWrapper = styled(LoginForm)`
  overflow: visible;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.level5};
`;

export const StepLabel = styled.h3`
  ${({ theme }) => css`
    font-size: ${theme.font.titleSmall.fontSize};
    font-weight: 600;
    color: ${theme.colors.onSurface};
    margin: 0;
  `}
`;

export const StepDescription = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.bodyMedium.fontSize};
    color: ${theme.colors.onSurfaceVariant};
    line-height: 1.5;
    margin: 0;
  `}
`;

export const QrContainer = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;
  background: #fff;

  ${({ theme }) => css`
    padding: ${theme.spacing.level5};
    border-radius: ${theme.borderRadius.small};
  `}
`;

export const SecretCode = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spacing.level3};
    padding: ${theme.spacing.level3} ${theme.spacing.level4};
    background: ${theme.colors.surfaceContainerLowest};
    border: 1px solid ${theme.colors.outlineVariant};
    border-radius: ${theme.borderRadius.small};
    font-family: ${CODE_FONT_FAMILY};
    font-size: ${theme.font.bodySmall.fontSize};
    color: ${theme.colors.onSurface};
    word-break: break-all;
  `}
`;

export const CopyButton = styled.button`
  ${({ theme }) => css`
    flex-shrink: 0;
    padding: 4px 10px;
    background: transparent;
    color: ${theme.colors.primary};
    border: 1px solid ${theme.colors.primary};
    border-radius: ${theme.borderRadius.small};
    font-size: ${theme.font.bodySmall.fontSize};
    cursor: pointer;

    &:hover {
      background: ${theme.colors.primaryContainer};
    }
  `}
`;
